import { render, staticRenderFns } from "./boas-vindas-passo.vue?vue&type=template&id=2b6e3b07&scoped=true&"
import script from "./boas-vindas-passo.vue?vue&type=script&lang=js&"
export * from "./boas-vindas-passo.vue?vue&type=script&lang=js&"
import style0 from "./boas-vindas-passo.vue?vue&type=style&index=0&id=2b6e3b07&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6e3b07",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b6e3b07')) {
      api.createRecord('2b6e3b07', component.options)
    } else {
      api.reload('2b6e3b07', component.options)
    }
    module.hot.accept("./boas-vindas-passo.vue?vue&type=template&id=2b6e3b07&scoped=true&", function () {
      api.rerender('2b6e3b07', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/boas-vindas-falada/boas-vindas-passo.vue"
export default component.exports